import { FormControl, FormBuilder } from "@angular/forms";
import { FieldFactory, ParentFieldFactory, CreateFormContextOptions } from "../field-factory";
import { DynamicSingleController } from "./dynamic-single-controller";
import { SingleFormFieldSetting } from "./single-form-field-setting";
import { FormContext } from "../../form/form-context";
import { FormRootDirective } from "../../form/form-root.directive";
import { ViewRef } from "@angular/core";

export class SingleFieldFactory implements FieldFactory<FormControl, SingleFormFieldSetting<any>> {
  constructor(private parentFieldFactory: ParentFieldFactory, private formBuilder: FormBuilder) {}

  public create<M>({
    initialValue: value,
    formControl,
    setting,
    settings
  }: CreateFormContextOptions<M, FormControl, SingleFormFieldSetting<M>>): FormContext<M, FormControl> {
    if (!formControl) {
      formControl = this.formBuilder.control(value);
      formControl.setValidators(setting.validators ? setting.validators : []);
      formControl.setAsyncValidators(setting.asyncValidators ? setting.asyncValidators : []);
    }

    const dynamicController = new DynamicSingleController(formControl, this.parentFieldFactory, setting, settings);

    return this.parentFieldFactory.resolveComponent<M, FormControl>(formControl, setting, value, dynamicController);
  }

  public render(formRoot: FormRootDirective, root: FormContext<any, FormControl>): ViewRef {
    const viewRef = formRoot.viewContainerRef.insert(root.componentRef.hostView);
    viewRef.detectChanges();
    return viewRef;
  }

  public updateChildren(context: FormContext<any, FormControl>) {}
}
